export default __webpack_public_path__ + "static/media/GLM-photo-showing-3-sides-1-e1605565501564.cb27c3dd.png";